module.exports = __webpack_public_path__ + "static/media/view_insinghts.8d7b2c5d.svg";